import './MatchBoard.less';

import React, { useRef } from 'react';
import i18n from '@i18n';
import moment from 'moment';
import immutableMemo from '@/common/immutableMemo';
import clsx from 'clsx';
import { BackButton } from '@/common/components/HelperButtons';

export const MatchBoardPrematch = immutableMemo(function MatchBoardPrematch({ sportEvent, sportName, visibleHeader }) {
    const stickyRef = useRef(null);
    if (!sportEvent) {
        return null;
    }
    const home = sportEvent.getIn(['participants', 0]);
    const away = sportEvent.getIn(['participants', 1]);
    const startOn = moment(sportEvent.get('expiration')).format('D.M.Y H:mm');
    const tournamentName = sportEvent.get('tournamentName');
    const tournamentNote = sportEvent.get('tournamentNote');
    const matchNote = sportEvent.get('matchNote');
    const sticky = !visibleHeader && stickyRef?.current;
    const sportId = sportEvent?.get('sportId');

    return (
        <div ref={stickyRef} className={`detail-event-prematch pl-15 pt-3 pr-20 bg-${sportId}`}>
            <BackButton trackData={{ category: 'Ponuka', action: 'Spat' }} />
            {tournamentName && (
                <div className="fs-12 pt-8 pb-10 flex flex-col pr-30 c-white">
                    <div className="flex justify-center">
                        {tournamentName}
                        <span className={`${sticky ? 'date-visible' : 'date-invisible'}`}>{`, ${startOn}`}</span>
                        {tournamentNote && <span>{tournamentNote}</span>}
                    </div>
                    {<HomeAwayTitle home={home} away={away} sticky={sticky} />}

                    {matchNote && <div className="match-board-note pt-5 text-center">{'(' + matchNote + ')'}</div>}
                </div>
            )}
        </div>
    );
});

const HomeAwayTitle = ({ home, away, sticky }) => (
    <div className={clsx(`flex-center text-bold full-width ${sticky ? 'home-away-visible' : 'home-away-invisible'}`)}>
        {away ? (
            <>
                <span className="flex-1 text-right">{home} </span>
                <span className="vs px-10">{i18n('homeAway.vs.separator')}</span>
                <span className="flex-1">{away}</span>
            </>
        ) : (
            <div className="name">{home}</div>
        )}
    </div>
);
